import { appSettings } from '@/config/index';
import { logger } from '@/infra/logging';

export function handleRequestError(error: Error): Promise<never> {
  if (appSettings.app.isDevelopment) {
    logger.error('Request configuration error', error, {
      component: 'ApiClient.RequestInterceptor',
    });
  }
  return Promise.reject(error);
}
